import React from "react"
import styled from "styled-components"
import { graphql, useStaticQuery } from "gatsby"
import options from "../../../constants/home/whoAreYouOptions"
import ViewTabs from "./ViewTabs"
import ViewList from "./ViewList"

const query = graphql`
  {
    allFile(
      filter: { relativeDirectory: { eq: "whoareyou" } }
      sort: { fields: name }
    ) {
      nodes {
        relativeDirectory
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
          }
        }
      }
    }
  }
`

const WhoAreYou = () => {
  const data = useStaticQuery(query)
  const {
    allFile: { nodes: images },
  } = data
  return (
    <Wrapper>
      <ViewList options={options} images={images} />
      <ViewTabs options={options} images={images} />
    </Wrapper>
  )
}

const Wrapper = styled.section`
  
  color: var(--clr-white);
`

export default WhoAreYou
